<template>
    <div class="container-fluid  text">

        <div class="ps-2 pe-2 mb-3">
            <label for="name" class="form-label"
              >Sorteio</label
            >
            <input
              :value="prizedraw?.name"
              type="text"
              class="form-control"
              id="name"
              required
              placeholder="Nome do Cliente"
              readonly
            />
            <p class="p-error-label">{{ errorLabel?.nameClient || errorLabel?.error }}</p>
        </div>
        <div class="ps-2 pe-2 mb-3">
            <label for="name" class="form-label"
              >Nome do cliente</label
            >
            <input
              v-model="nameClient"
              type="text"
              class="form-control"
              id="name"
              required
              placeholder="Nome do Cliente"
            />
            <p class="p-error-label">{{ errorLabel?.nameClient || errorLabel?.error }}</p>
        </div>

        <div class="ps-2 pe-2 mb-3">
            <label for="name" class="form-label"
              >Quantidade de Cupom</label
            >
            <input
              v-model="coupon"
              type="number"
              class="form-control"
              id="count"
              required
              placeholder="Quantidade de Cupom"
            />
            <p class="p-error-label">{{ errorLabel?.coupon || errorLabel?.error }}</p>
        </div>

        <div class="d-flex justify-content-center mb-2">
            <button 
                class="btn btn-dark me-1 col-6" 
                @click="registerPrizeDrawClient"
                :disabled="!nameClient ? true : false"
            >
              Cadastrar
            </button>
            <button 
              class="btn btn-danger ms-1 col-6" 
              @click="openCreateMaterial"
              id="closeButtonAdd"
              data-bs-dismiss="modal" 
              aria-label="Close"
            >
              Cancelar
            </button>
        </div> 
          
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import store from "../../store";
import { createPrizeClient } from "../../http"

export default {
setup() {

  const nameClient = ref('');
  const coupon = ref(0); 
  const prizedraw = computed(() => store.state.prizedraw);

  const errorLabel = ref({
    nameClient: null,
    coupon: null,
    error: null
  })

  const registerPrizeDrawClient = async () => {
    if(nameClient.value){
      await createPrizeClient({
        name: nameClient.value, 
        coupon: coupon.value, 
        prizeDraw: prizedraw.value?.id
      }).then((data)=>{
          if(data?.message){
            errorLabel.value.error = data?.message;
            return;
          }
          store.commit('setPrizedrawClient', {create: true, data: data});
          nameClient.value = '';
          coupon.value = 0;
          document.getElementById("closeButtonAdd").click();
        });
    }else{
      errorLabel.value.nameClient = "Campo obrigatório.";
      errorLabel.value.coupon = "Campo obrigatório.";
    }
  }

  return {
      registerPrizeDrawClient,
      nameClient,
      coupon,
      prizedraw
  };
}
};
</script>

<style>
.p-error-label {
  font-size: 14px;
  color: red;
}
</style>
